import sunIcon from "../assets/planet-icons/sun.svg";
import mercuryIcon from "../assets/planet-icons/mercury.svg";
import venusIcon from "../assets/planet-icons/venus.svg";
import earthIcon from "../assets/planet-icons/earth.svg";
import moonIcon from "../assets/planet-icons/moon.svg";
import marsIcon from "../assets/planet-icons/mars.svg";
import jupiterIcon from "../assets/planet-icons/jupiter.svg";
import saturnIcon from "../assets/planet-icons/saturn.svg";
import uranusIcon from "../assets/planet-icons/uranus.svg";
import neptuneIcon from "../assets/planet-icons/neptune.svg";
import plutoIcon from "../assets/planet-icons/pluto.svg";

export const planetIcons = {
  sun: sunIcon,
  mercury: mercuryIcon,
  venus: venusIcon,
  earth: earthIcon,
  moon: moonIcon,
  mars: marsIcon,
  jupiter: jupiterIcon,
  saturn: saturnIcon,
  uranus: uranusIcon,
  neptune: neptuneIcon,
  pluto: plutoIcon,
};
